export default "__VITE_ASSET__CgCY0PQG__"